import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { ParametrosMaestro } from 'src/app/models/common/enumModel';
import { SearchResultModel } from 'src/app/models/common/SearchResultModel';
import { FilterGbuModel } from 'src/app/models/gbu/FilterGbuModel';
import { GbuModel } from 'src/app/models/gbu/GbuModel';
import { IFilterGbuModel } from 'src/app/models/interfaces/gbus/IFilterGbuModel';
import { IGbuModel } from 'src/app/models/interfaces/gbus/IGbuModel';
import { ParametroModel } from 'src/app/models/parametros/ParametroModel';
import { GbuService } from 'src/app/services/Gbu/gbu.service';
import { ParametroService } from 'src/app/services/parametros/parametro.service';

@Component({
  selector: 'app-configuracion-gbu-listar',
  templateUrl: './configuracion-gbu-listar.component.html',
  styleUrls: ['./configuracion-gbu-listar.component.css']
})
export class ConfiguracionGbuListarComponent implements OnInit {
  model!: SearchResultModel<IGbuModel[]>;
  filter: IFilterGbuModel = new FilterGbuModel();
  listaEstados: ParametroModel[] = new Array<ParametroModel>();
  resultsLength = 0;
  currentPage = 0;

  displayedColumns: string[] = [
    'id',
    'nombre',
    'estado',
    'acciones'
  ];
  
  @ViewChild('paginator') paginator!: MatPaginator;

  constructor(
    private serviceGbu: GbuService,
    private serviceParametros: ParametroService
  ) { 
    this.model = new SearchResultModel<IGbuModel[]>(false, new Array<GbuModel>(), 0, 1, 0);
  }

  ngOnInit(): void {
    this.serviceParametros.getDetalles(ParametrosMaestro.ESTADO_CONFIG_MAESTRO).subscribe((data) => {
      this.listaEstados = data.items;
    });
    
    this.serviceGbu.getListFiltered(this.filter).subscribe((data) => {
      this.model = data;
      this.resultsLength = data.total;
    });
  }

  search(): void{
    this.filter.page = 1;
    this.filter.pageSize = 30;
    this.serviceGbu
      .getListFiltered(this.filter)
      .subscribe((data) => {
        this.model = data;
        this.resultsLength = data.total;
        this.currentPage = 0;
        this.paginator.firstPage();
      });
  }

  getPaginatorData(event: any) {
    this.filter.page = event.pageIndex + 1;
    this.filter.pageSize = event.pageSize;
    this.serviceGbu
      .getListFiltered(this.filter)
      .subscribe((data) => {
        this.model = data;
        this.resultsLength = data.total;
      });
  }

}
